import { Button } from '@workspace/ui/components/button';
import { ArrowRight, Check } from 'lucide-react';
import { m } from '~/paraglide/messages.js';

type Props = {
  onNext: () => void;
  onSkip: () => void;
};

const CARD_BENEFITS = [
  m['organization.activate_card.benefit_1'](),
  m['organization.activate_card.benefit_2'](),
  m['organization.activate_card.benefit_3'](),
  m['organization.activate_card.benefit_4'](),
  m['organization.activate_card.benefit_5'](),
];

export function ActivateYourCardComponent({ onNext, onSkip }: Props) {
  return (
    <div className="flex flex-col items-center space-y-8">
      <div className="relative w-full max-w-sm">
        <img src="/card.png" alt="card" />
      </div>

      <div className="w-full space-y-6">
        <h3 className="text-xl font-bold text-white">
          {m['organization.activate_card.card_title']()}
        </h3>

        <ul className="space-y-3">
          {CARD_BENEFITS.map((benefit, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full">
                <Check className="h-3 w-3" />
              </div>
              <span className="text-sm text-gray-300">{benefit}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="w-full space-y-3 pt-4">
        <Button
          onClick={onNext}
          className="flex w-full items-center justify-center gap-2 rounded-lg px-6 py-6 font-semibold transition-all"
        >
          {m['organization.activate_card.verify_and_activate']()}
          <ArrowRight className="h-5 w-5" />
        </Button>

        <button
          type="button"
          onClick={onSkip}
          className="w-full rounded-lg px-6 py-3 text-sm font-medium text-gray-400 transition-colors hover:text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          {m['organization.activate_card.do_it_later']()}
        </button>
      </div>
    </div>
  );
}
